import XYZEmail from "../../../../content/pages/contact/xyz-email.inline.svg";
import * as React from 'react';
export default {
  XYZEmail,
  React
};